var map = {
	"./brand/avalon_logo.png": "f9e1",
	"./brand/liqpay.png": "3b73",
	"./brand/logo_color.png": "2a0f",
	"./brand/logo_fine.png": "caf8",
	"./brand/logo_fine_white.png": "f088",
	"./brand/logo_fine_white_small.png": "1b6d",
	"./brand/logo_mdu_white.png": "ee33",
	"./brand/logo_mnu_white.png": "3d68",
	"./brand/logo_westudy_color.png": "a73a",
	"./brand/logo_westudy_small_white.png": "0a14",
	"./brand/logo_westudy_white.png": "df25",
	"./brand/logo_white.png": "c7ec",
	"./brand/logo_white_small.png": "8040",
	"./brand/newlogo.png": "0de6",
	"./brand/newlogo2.png": "e2b4",
	"./brand/newlogo3.png": "ef19",
	"./brand/newlogo4.png": "0cef",
	"./brand/newlogo5.png": "bb0b",
	"./brand/newlogo6.png": "4fcf",
	"./brand/newlogo7.png": "f0d5",
	"./brand/newlogo_white.png": "f250",
	"./brand/university_logo.jpg": "628c",
	"./brand/visa.png": "a6cb",
	"./brand/westudy_color.png": "3aec",
	"./certificates/cert_1.jpg": "893a",
	"./css/quill-disable-padding.css": "bb72",
	"./css/quill.bubble.css": "e30f",
	"./fonts/Ambulatoria_D/AmbulatoriaD-Light.woff2": "a885",
	"./fonts/Ambulatoria_D/AmbulatoriaD-Regular.woff2": "7e32",
	"./fonts/Ambulatoria_D/AmbulatoriaD-SemiBold.woff2": "302a",
	"./illustrations/consultation.png": "9719",
	"./illustrations/onboarding_clean.png": "5a66",
	"./illustrations/pricing_1.png": "2019",
	"./illustrations/pricing_2.png": "3347",
	"./illustrations/pricing_3.png": "5196",
	"./illustrations/space.png": "ec9f",
	"./illustrations/trial.png": "ad8f",
	"./illustrations/updates.png": "3497",
	"./illustrations/vaulanteer.png": "99fc",
	"./img/about_us.png": "15ef",
	"./img/art/404.png": "753b",
	"./img/art/payment_expired.png": "183f",
	"./img/art/updates.png": "02b9",
	"./img/avalon/404.png": "ecc7",
	"./img/avalon/westudy_constructor.png": "f3a3",
	"./img/avalon/wizard_from_blocks.png": "6509",
	"./img/avalon/wizard_from_template.png": "9d7e",
	"./img/bg-pages.jpg": "df30",
	"./img/bg_slide_1.png": "c174",
	"./img/bg_slide_2.png": "44c9",
	"./img/bg_slide_3.jpg": "2ef5",
	"./img/bg_slide_4.jpeg": "9335",
	"./img/bg_slide_5.jpg": "642e",
	"./img/bg_slide_6.jpg": "1e42",
	"./img/bg_slide_7.jpeg": "2e52",
	"./img/business-background-backgrounds-business-1-5c9b8f75536e8.png": "ada0",
	"./img/certificate.png": "cc9f",
	"./img/clients/authors/companies/0.png": "8967",
	"./img/clients/authors/universities/0.png": "7431",
	"./img/clients/authors/universities/1.png": "5ca8",
	"./img/clients/kihteva.png": "dcc1",
	"./img/clients/kiparenko.png": "51b7",
	"./img/clients/logos/client_logo_1.png": "06290",
	"./img/clients/logos/client_logo_2.png": "9c8a",
	"./img/clients/logos/client_logo_3.png": "8b31",
	"./img/clients/logos/client_logo_4.png": "4eb8",
	"./img/clients/logos/client_logo_5.png": "08be",
	"./img/clients/logos/client_logo_6.png": "20c8",
	"./img/clients/logos/client_logo_7.png": "9ed6",
	"./img/clients/logos/client_logo_8.png": "73f8",
	"./img/clients/logos/companies/0.png": "6fbd",
	"./img/clients/logos/universities/0.png": "4589",
	"./img/clients/logos/universities/1.png": "06d71",
	"./img/clients/lutsai.png": "51ef",
	"./img/course_blank.jpg": "caf5",
	"./img/dash.png": "678d",
	"./img/dashboard_screens/app_screen.png": "b2c5",
	"./img/dashboard_screens/main_slide_1.png": "a945",
	"./img/dashboard_screens/main_slide_2.png": "c857",
	"./img/dashboard_screens/main_slide_3.png": "33bd",
	"./img/dashboard_screens/main_slide_4.png": "b8c1",
	"./img/dashboard_screens/main_slide_5.png": "66ec",
	"./img/dashboard_screens/mobile_screen.png": "9014",
	"./img/dashboard_student.jpg": "3c09",
	"./img/dashboard_student.png": "7471e",
	"./img/day.jpg": "778d",
	"./img/download_apple.png": "158a",
	"./img/download_google.png": "c704",
	"./img/features/feature_1.png": "a594",
	"./img/features/feature_2.png": "4f66",
	"./img/features/feature_3.png": "0767",
	"./img/features/feature_4.png": "3178",
	"./img/features/feature_5.png": "6721",
	"./img/features/feature_6.png": "5db3",
	"./img/features/feature_7.png": "5046",
	"./img/features/feature_8.png": "f8bb",
	"./img/features/feature_payment.png": "200b",
	"./img/features/feature_payment_old.png": "2eda",
	"./img/fine1.png": "b929",
	"./img/fine2.jpg": "2dc6",
	"./img/fine_dashboard.png": "aaab",
	"./img/home-2.png": "eca7",
	"./img/homepage/payment_plan_1.png": "f1f5",
	"./img/homepage/payment_plan_2.png": "ba4a",
	"./img/homepage/payment_plan_3.png": "d14b",
	"./img/homepage/register_image.png": "d6c6",
	"./img/lnu_logo.jpg": "5e4a",
	"./img/login_img.png": "56a9",
	"./img/logos/android.png": "cde7",
	"./img/logos/ios.png": "a39e",
	"./img/logos/logo_ali.png": "662b",
	"./img/logos/logo_ali2.png": "881d",
	"./img/logos/logo_alicloud.png": "f1ba",
	"./img/logos/logo_amazon.png": "13dc",
	"./img/logos/logo_gsuite.png": "8207",
	"./img/logos/logo_microsoft.png": "7828",
	"./img/logos/logo_symfony.png": "0ec6",
	"./img/logos/telegram.png": "eb3d",
	"./img/logos/vuejs.png": "2ab4",
	"./img/lpnu_logo.jpg": "e8f3",
	"./img/main_westudy.png": "6b01",
	"./img/mnu_logo.jpg": "bc2a",
	"./img/mobile/mobile_app_promo.png": "36e6",
	"./img/mobile/mobile_img.png": "48e1",
	"./img/mobile/mobile_screens.png": "272c",
	"./img/newsletter/email_graphics.png": "b9df",
	"./img/newsletter/email_sent.png": "0111",
	"./img/partner/partner_program.png": "2e98",
	"./img/qrCodes/qr_westudy.png": "aaea",
	"./img/slider7.jpg": "e964",
	"./img/slider_contact.jpg": "9652",
	"./img/slider_contact2.jpg": "496f",
	"./img/slider_contact3.jpg": "220d",
	"./img/slider_contact4.jpg": "9867",
	"./img/student.png": "f070",
	"./img/support/avatar.png": "74fb",
	"./img/team/ryzhkov_oleksandr.png": "e715",
	"./img/team/ryzhkov_rostyslav.png": "ae0a",
	"./img/team/ryzhkov_serhiy.png": "eb9c",
	"./img/team/ryzhkov_vasyl.png": "15dd",
	"./img/team/ryzhkov_vasyl_2.png": "4326",
	"./img/team/ryzhkov_vasyl_3.png": "f63d",
	"./img/technologies_img.png": "d743",
	"./img/udpu_logo.jpg": "657d",
	"./img/uhsp_logo.jpg": "8880",
	"./img/updateDescriptionImage.png": "45b6",
	"./img/wave-mask.png": "63a3",
	"./img/welcomeImage.png": "65b5",
	"./img/westudy_online_screen.png": "5bf9",
	"./img/westudy_online_screens.png": "9c90",
	"./img/westudy_screen_student_dash.png": "4d97",
	"./img/westudy_team.png": "b037",
	"./img/wsDash.png": "1e09d",
	"./img/wsPublic.png": "2693",
	"./json/avalon/avalon_icon_set": "8ef4",
	"./json/avalon/avalon_icon_set.json": "8ef4",
	"./json/avalon/blocksConfig": "5ac3",
	"./json/avalon/blocksConfig.json": "5ac3",
	"./json/avalon/colors_variables": "2c19",
	"./json/avalon/colors_variables.json": "2c19",
	"./json/avalon/defaultConfig": "5573",
	"./json/avalon/defaultConfig.json": "5573",
	"./json/avalon/defaultHeader": "1380",
	"./json/avalon/defaultHeader.json": "1380",
	"./json/avalon/elements_config_variables": "bb28",
	"./json/avalon/elements_config_variables.json": "bb28",
	"./json/avalon/elements_design_config": "00fe",
	"./json/avalon/elements_design_config.json": "00fe",
	"./json/avalon/fonts_variables": "8eac",
	"./json/avalon/fonts_variables.json": "8eac",
	"./json/avalon/google/google_fonts": "6a8c",
	"./json/avalon/google/google_fonts.json": "6a8c",
	"./json/avalon/google/google_fonts_sizes": "5ce1",
	"./json/avalon/google/google_fonts_sizes.json": "5ce1",
	"./json/avalon/placeholder/courses_placeholder": "7d32",
	"./json/avalon/placeholder/courses_placeholder.json": "7d32",
	"./json/avalon/placeholder/news_placeholder": "10e1",
	"./json/avalon/placeholder/news_placeholder.json": "10e1",
	"./json/country_codes_select": "152a",
	"./json/country_codes_select.json": "152a",
	"./json/fonts_list": "14d0",
	"./json/fonts_list.json": "14d0",
	"./json/fonts_sizes": "e7e0",
	"./json/fonts_sizes.json": "e7e0",
	"./logo.png": "cf05",
	"./onboarding/chatbots_botfather.jpeg": "625c",
	"./onboarding/chatbots_constructor.png": "080c",
	"./onboarding/chatbots_link.png": "9da8",
	"./onboarding/chatbots_link_key.png": "7485",
	"./onboarding/chatbots_notifications.png": "9c77",
	"./onboarding/сhatbots.jpeg": "caaa",
	"./payment_systems/fondy_logo.png": "907d",
	"./payment_systems/liqpay_logo.png": "2ad7",
	"./payment_systems/monobank_logo.png": "c887",
	"./payment_systems/wayforpay_logo.png": "25fd",
	"./placeholder/specialty.jpg": "858b",
	"./placeholder/user_blank.jpg": "bd09",
	"./socials/telegram.png": "c8f8",
	"./sounds/notification.mp3": "a321",
	"./start/natalya.png": "1e96",
	"./start/site_builder_inst.png": "012d",
	"./svg/masks/parallel.svg": "d45f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";